import { SelectData } from 'mui-rff';

export const DEFAULT_SELECT_VALUE: SelectData = {
  value: '',
  label: '-'
};
